import "regenerator-runtime/runtime";

import React from "react";

class InfiniteList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      count: 0,
      isLoading: false
    };

    this.loadMoreItems = this.loadMoreItems.bind(this);
  }

  componentDidMount() {
    console.log("InfiniteList componentDidMount");

    /* let data = loadMorePosts();
     * console.log("data: ", data); */
  }

  isItemLoaded = ({ index }) => !!this.state.items[index];

  async loadMoreItems() {
    console.log("loadMoreItems: ");

    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true
    });

    console.log("loadMoreItems loading...");

    let response = await fetch(`/fashion/infinite_load_more`);

    let data = await response.json();
    console.log("data: ", data);

    let items = this.state.items;
    items.push(data);

    this.setState({
      items: items,
      isLoading: false,
      count: items.length
    });

    console.log("loadMoreItems loaded.");

    return data;
  }

  renderItem = ({ index, style }) => {
    console.log("renderItem: ", index);
    let content;
    if (!this.isItemLoaded({ index })) {
      content = "Loading...";
    } else {
      const item = this.state.items[index];
      console.log("item: ", item);

      content = "loaded";
      content = item.html;
    }

    return <div style={style} dangerouslySetInnerHTML={{ __html: content }} />;
  };

  renderItems() {
    return this.state.items.map((item, index) => this.renderItem(index));
  }

  // renderItems = ({}) => {

  // };

  render() {
    console.log("InfiniteList render");

    return <div className="fashion-vertical">{this.renderItems()}</div>;
  }
}

export default InfiniteList;
